<script setup lang="ts">
import DatePickerField from '@/components/Fields/DatePickerField.vue'
import StackLayout from '@/components/Layouts/StackLayout.vue'
import type { AdminApiFiltersType } from '@/types/filters/AdminFilters'
import DebouncedInputField from '../../../../components/Fields/DebouncedInputField.vue'

type Props = {
    filters: AdminApiFiltersType
}

defineProps<Props>()
type Emits = {
    (e: 'change', value: AdminApiFiltersType): void
}
defineEmits<Emits>()
</script>

<template>
    <StackLayout :gap="8" direction="column">
        <StackLayout :gap="8" class="responsive-width" isResponsiveSmallScreen>
            <DebouncedInputField
                :label="$t('api.filters.name')"
                :modelValue="filters.name"
                @change="$emit('change', { name: $event })"
                class="responsive-width" />
            <StackLayout :gap="8" class="full-width">
                <DatePickerField
                    :label="$t('api.filters.expirationDateFrom')"
                    :modelValue="filters.expirationDateFrom"
                    @change="$emit('change', { expirationDateFrom: $event })"
                    :min-date="new Date()"
                    class="full-width" />
                <DatePickerField
                    :label="$t('api.filters.expirationDateTo')"
                    :modelValue="filters.expirationDateTo"
                    @change="$emit('change', { expirationDateTo: $event })"
                    :min-date="new Date()"
                    class="full-width" />
            </StackLayout>
        </StackLayout>
    </StackLayout>
</template>
